import React, { useEffect, useState } from "react";

import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem.js";
import LoadingData from "components/Common/LoadingData";
import NotiAdd from "./NotiAdd";
import NotiList from "./NotiList";
import { getAllNoti } from "contexts/API/CommonSetting/Notification";
import { useSweetAlert } from "components/Alert/SweetAlert";

const Notification = props => {
  const [data, setData] = useState([]);
  const { sweetAlerts } = useSweetAlert();

  const [loading, setLoading] = useState(false);

  function getNoti() {
    getAllNoti()
      .then(result => {
        setLoading(true);
        setData(result.data.data);

        setLoading(false);
      })
      .catch(err => {
        setLoading(false);
        sweetAlerts.error("ไม่สามารถค้นหาข้อมูลได้", err.toString());
      });
  }
  useEffect(() => {
    getNoti();
  }, []);

  //const [projects, setProject] = useState(projectData);

  const addSuccess = project => {
    // data = [{ id: 0, value: "" }, ...data];
    // setData(data => project.concat(data));
    getNoti();
  };

  const delSuccess = project => {
    // project.id = projectData.length + 1;

    setData(project);
    // setProject([...projects, project]);
  };
  return (
    <GridContainer>
      <GridItem xs={12} sm={4} md={4}>
        <NotiAdd onaddSuccess={addSuccess} />
      </GridItem>

      <GridItem xs={12} sm={8} md={8}>
        {loading ? (
          <LoadingData />
        ) : (
          <NotiList NotiData={data} onaddSuccess={delSuccess} />
        )}
      </GridItem>
    </GridContainer>
  );
};
export default Notification;
